"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

require("core-js/modules/es6.function.name");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.number.constructor");

var _cmsWorkOrder = require("@/api/cmsWorkOrder");

var _cust = require("@/api/cust");

var _commonUpload = _interopRequireDefault(require("@/views/cms/common/commonUpload"));

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default2 = {
  name: 'BasicInfo',
  components: {
    CommonUpload: _commonUpload.default
  },
  props: {
    custId: {
      type: [String, Number],
      required: true
    },
    basicInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      form: {
        focus: '',
        needProduct1: [],
        needProduct2: [],
        needProduct3: [],
        budget: '',
        material: '',
        budgetImgs: [],
        remark: ''
      },
      rules: {
        focus: [],
        needProduct1: [],
        needProduct2: [],
        needProduct3: [],
        budget: [],
        material: [],
        budgetImgs: [],
        remark: []
      },
      budgetImgs: [],
      isShowImgs: true
    };
  },
  computed: {
    baseApi: function baseApi() {
      return this.$store.getters.baseApi;
    },
    filesUploadApi: function filesUploadApi() {
      return this.$store.getters.filesUploadApi;
    },
    imgPreviewPrefix: function imgPreviewPrefix() {
      return this.$store.getters.imgPreviewPrefix;
    }
  },
  mounted: function mounted() {
    // 组件挂载时查询接口获取客户信息
    this.init();
  },
  watch: {
    // 监听basicInfo变化，重新加载数据
    basicInfo: {
      handler: function handler(newVal) {
        if (newVal) {
          this.init();
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    init: function init() {
      if (this.basicInfo) {
        var custInfo = this.basicInfo;
        var budgetImgs = [];

        if (custInfo.budgetImgs) {
          if (typeof custInfo.budgetImgs === 'string') {
            try {
              budgetImgs = JSON.parse(custInfo.budgetImgs);
            } catch (e) {
              console.error('解析 budgetImgs 失败:', e);
            }
          } else if (Array.isArray(custInfo.budgetImgs)) {
            budgetImgs = custInfo.budgetImgs;
          }
        }

        var material = '';

        if (custInfo.material) {
          if (Array.isArray(custInfo.material)) {
            material = custInfo.material.join(', ');
          } else if (typeof custInfo.material === 'string') {
            material = custInfo.material;
          }
        }

        this.form = {
          focus: custInfo.styleFocus || '',
          needProduct1: custInfo.needProduct1 ? JSON.parse(custInfo.needProduct1) : [],
          needProduct2: custInfo.needProduct2 ? JSON.parse(custInfo.needProduct2) : [],
          needProduct3: custInfo.needProduct3 ? JSON.parse(custInfo.needProduct3) : [],
          budget: custInfo.budget || '',
          material: material,
          budgetImgs: budgetImgs,
          remark: custInfo.remarks || ''
        };
      }
    },
    validate: function validate() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.$refs.basicInfoForm.validate(function (valid) {
          if (valid) {
            resolve(true);
          } else {
            reject(false);
          }
        });
      });
    },
    // 同步数据到父组件
    syncData: function syncData() {
      this.form.budgetImgs = this.getBudgetImgs();
      this.$emit('data-change', this.form); // 重置上传组件

      if (this.$refs.commonUpload) {
        this.$refs.commonUpload.clearImgs();
      } // 重置本地上传图片数组


      this.budgetImgs = [];
    },
    // 处理上传成功
    uploadImgs: function uploadImgs(imgs) {
      this.budgetImgs = imgs;
    },
    // 处理删除成功
    delImg: function delImg(imgs) {
      this.budgetImgs = imgs;
    },
    // 生成图片URL
    imgUrl: function imgUrl(imgs) {
      var _this2 = this;

      imgs = typeof imgs === 'string' ? JSON.parse(imgs) : imgs;
      var imgUrls = [];

      if (imgs && Array.isArray(imgs)) {
        imgs.forEach(function (img) {
          img = img.type == undefined ? JSON.parse(img) : img;
          imgUrls.push(_this2.imgPreviewPrefix + img.realName);
        });
      }

      return imgUrls;
    },
    // 删除指定索引的图片
    delImgIndex: function delImgIndex(index) {
      this.form.budgetImgs = typeof this.form.budgetImgs === 'string' ? JSON.parse(this.form.budgetImgs) : this.form.budgetImgs;
      this.form.budgetImgs.splice(index, 1);
      this.form.budgetImgs = JSON.stringify(this.form.budgetImgs);
      this.syncData();
    },
    // 获取预算图数据
    getBudgetImgs: function getBudgetImgs() {
      var budget = this.form.budgetImgs != undefined ? this.form.budgetImgs.indexOf("[") > -1 ? JSON.parse(this.form.budgetImgs) : this.form.budgetImgs : [];
      this.budgetImgs.forEach(function (img) {
        if (budget.indexOf(img) == -1) {
          budget.push(img);
        }
      });
      return budget;
    },
    // 保存客户基本情况
    saveBasicInfo: function saveBasicInfo() {
      var _this3 = this;

      // 构建保存的数据对象
      var saveData = {
        id: this.custId,
        name: this.basicInfo.name || '',
        // 客户基本情况
        styleFocus: this.form.focus,
        needProduct1: JSON.stringify(this.form.needProduct1),
        needProduct2: JSON.stringify(this.form.needProduct2),
        needProduct3: JSON.stringify(this.form.needProduct3),
        budget: this.form.budget,
        material: this.form.material,
        budgetImgs: this.form.budgetImgs,
        remarks: this.form.remark
      }; // 调用后端API保存数据

      (0, _cust.editBaseInfo)(saveData).then(function (response) {
        // 显示保存成功提示
        _this3.$message.success('客户基本情况保存成功'); // 通知父组件更新currentCustomer


        _this3.$emit('update-current-customer', _objectSpread(_objectSpread({}, _this3.basicInfo), {}, {
          styleFocus: _this3.form.focus,
          needProduct1: JSON.stringify(_this3.form.needProduct1),
          needProduct2: JSON.stringify(_this3.form.needProduct2),
          needProduct3: JSON.stringify(_this3.form.needProduct3),
          budget: _this3.form.budget,
          material: _this3.form.material,
          budgetImgs: _this3.form.budgetImgs,
          remarks: _this3.form.remark
        }));
      }).catch(function (error) {
        _this3.$message.error('保存失败，请重试');
      });
    }
  }
};
exports.default = _default2;